import { useCallback, useEffect, useRef, useState } from "react";
import { useAtom } from "jotai";
import { activeTabAtom } from "../../utils/atoms/activeTabAtom";
import { useTranslation } from 'react-i18next';
import SideMenu from "../../components/sideMenu/index";
import EditProjectDetails from "../../components/editProjectDetails/index";
import LoadProject from "../../components/loadProject/";
import Simulation from "../../components/simulation/index";
import MGA_API from "../../api/index";
import "../Dashboard/style.scss";
import "./styles.scss";
import RTLSideMenu from "../../components/RTLSideMenu";
import { collapseAtom } from "../../utils/atoms/collapseAtom";
import { sideMenu } from "../../utils/atoms/sideMenuAtom";
import Result from "../../components/result";
import { useResetAtom } from "jotai/utils";
import {
  flattenCountComponentDTOList,
  flattenDesignCountComponent,
  projectDetailsAtom,
} from "../../utils/atoms/projectDetailsAtom";
import { componentsAtom } from "../../utils/atoms/componentsAtom";
import { selectedCurrentComponent } from "../../utils/atoms/selectedComponentAtom";
import { progressStepAtom } from "../../utils/atoms/progressLoadingAtom";
import { gridAtom } from "../../utils/atoms/gridAtom";
import { useNavigate, useLocation } from "react-router-dom";
import { componentStatusAtom } from "../../utils/atoms/componentStatus";
import SnackBarJs from "../../components/SnackBar.js";
import { loadDateAtom } from "../../utils/atoms/loadDateAtom.js";
import { useTour } from "../../utils/tour/index.js";
import { tourAtom } from "../../utils/atoms/tourAtom.js";
import "../../utils/tour/tour.css";
import {
  useAssessmentRouteParams,
  useCurrentDesignVersion,
  useDesignComponentFallbackModal,
  useTabAccessWithFallback,
} from "../../constants/helper.js";
import { loaderAtom } from "../../utils/atoms/loaderAtom.js";
import SEConfirmModal from "../../components/common/SEConfirmModal.js";
import { getErrorMessage } from "../../utils/errorUtils.js";
const MGAAssesment = () => {
  // Track if RTLSideMenu is floating
  const [projectDetails, setProjectDetails] = useAtom(projectDetailsAtom);
  const { t } = useTranslation();

  const [isFloatingMenu, setIsFloatingMenu] = useState(false);
  const { projectId, designId, designVersionId } = useAssessmentRouteParams();
  const navigate = useNavigate();
  const location = useLocation();
  const allowedTabs = ["DESIGN", "SIMULATION", "RESULT"]; // allowed tab values
  const [modalOpen, setModalOpen] = useState(false);
  const [blockedTab, setBlockedTab] = useState(null);
  // Use fallback modal hook for design/version
  const designComponentsList = projectDetails?.designComponentsList || [];
  const { modal: fallbackModal } = useDesignComponentFallbackModal({
    designComponentsList,
    designId,
    designVersionId,
    projectId,
  });
  const snackBarRef = useRef(null);
  const apiRef = useRef(null);
  if (!apiRef.current) {
    apiRef.current = new MGA_API();
  }
  // Only call useTabAccessWithFallback after projectDetails are set in atom
  const [fallbackModalDesign, setFallbackModalDesign] = useState(null);
  // useEffect(() => {
  //   if (
  //     projectDetails?.designWithVersionsDTOList &&
  //     projectDetails?.designComponentsList &&
  //     Array.isArray(projectDetails?.designWithVersionsDTOList) &&
  //     Array.isArray(projectDetails?.designComponentsList)
  //   ) {
  //     // Call the hook and set modal in state
  //      let hasGrid = false;
  // let hasController = false;
  // let versionStatus = null;
  // let designComponentsList = projectDetails?.designComponentsList || [];
  // let designWithVersionsDTOList =
  //   projectDetails?.designWithVersionsDTOList || [];
  // if (Array.isArray(designComponentsList)) {
  //   const design = designComponentsList.find(
  //     (d) => String(d.designId) === String(designId)
  //   );
  //   let version;
  //   if (design && Array.isArray(design.designVersionComponents)) {
  //     version = design.designVersionComponents.find(
  //       (v) => String(v.designVersionId) === String(designVersionId)
  //     );
  //   }
  //   const countList = version?.countComponentDTOList || [];
  //   hasGrid = countList.some((c) => c.componentType === "Grid");
  //   hasController = countList.some((c) => c.componentType === "Controller");
  // }
  // if (Array.isArray(designWithVersionsDTOList)) {
  //   const designObj = designWithVersionsDTOList.find(
  //     (d) => String(d.designDTO?.designId) === String(designId)
  //   );
  //   if (designObj && Array.isArray(designObj.designVersionDTO)) {
  //     const versionObj = designObj.designVersionDTO.find(
  //       (v) => String(v.designVersionId) === String(designVersionId)
  //     );
  //     versionStatus = versionObj?.versionStatus || null;
  //   }
  // }
  // const canViewSimulation =
  //   (hasGrid && hasController) || versionStatus === "COMPLETED";

  //  const params = new URLSearchParams(window.location.search);
  //   const tab = params.get("tab")?.toUpperCase();
  //   if (["SIMULATION", "RESULT"].includes(tab) && !canViewSimulation) {
  //     setBlockedTab(tab);
  //     setModalOpen(true);
  //   }

  // }
  //   //   setFallbackModalDesign(modal);
  //   // } else {
  //   //   setFallbackModalDesign(null);
  //   // }
  // }, [projectDetails?.designWithVersionsDTOList, projectDetails?.designComponentsList]);
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [collapseSideMenu, setCollapseSideMenu] = useAtom(collapseAtom);
  const [sideMenuShow] = useAtom(sideMenu);
  const [activeTab] = useAtom(activeTabAtom);
  const [, setLoadDate] = useAtom(loadDateAtom);
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(true);

  const resetSelectedCurrentComponent = useResetAtom(selectedCurrentComponent);
  const resetComponentDetails = useResetAtom(componentsAtom);
  const resetProjectDetails = useResetAtom(projectDetailsAtom);
  const resetCollapseSideMenu = useResetAtom(collapseAtom);
  const resetComponentStatus = useResetAtom(componentStatusAtom);
  const resetSideMenuShow = useResetAtom(sideMenu);
  const resetActiveTab = useResetAtom(activeTabAtom);
  const [loader, setLoader] = useAtom(loaderAtom);

  const resetProgressStepAtom = useResetAtom(progressStepAtom);
  const resetGridAtom = useResetAtom(gridAtom);
  const [tour] = useAtom(tourAtom);
  const { startTour } = useTour();
  // Sidebar now overlays on hover; reserve only collapsed width in layout
  const leftSideMenuWidth = "80px";
  const [, setActiveState] = useAtom(activeTabAtom);

  const handleModalOk = () => {
    setModalOpen(false);
    if (setActiveState) setActiveState("DESIGN");
    navigate("?tab=design");
  };

  // Ensure a default tab=design when query param missing or invalid.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentTab = params.get("tab");
    const upper = currentTab ? currentTab.toUpperCase() : null;
    if (!upper || !allowedTabs.includes(upper)) {
      // preserve existing params except tab
      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", "design");
      navigate({ search: newParams.toString() }, { replace: true });
      if (setActiveState) setActiveState("DESIGN");
      return;
    }
    // Sync atom with URL if user manually changed it
    if (upper !== activeTab && setActiveState) {
      setActiveState(upper);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const toggleEditDetails = () => {
    setIsEditVisible(!isEditVisible);
  };
  const callSnackbar = useCallback((type, message) => {
    setSnackBar({ type, message });
    if (snackBarRef.current) snackBarRef.current.open = true;
    if(type === 'error'){
      console.error(message);
      snackBarRef.current.canClose = true;
    }
  }, []);
  // Start tour only after at least one data-intro element is in the DOM to avoid race conditions
  useEffect(() => {
    if (!tour) return;
    let cancelled = false;
    const hasSteps = () => document.querySelector("[data-intro]");
    const attemptStart = (tries = 0) => {
      if (cancelled) return;
      if (hasSteps()) {
        startTour();
        return;
      }
      if (tries > 40) {
        // fallback ~40 frames (~600ms) then start anyway
        startTour();
        return;
      }
      requestAnimationFrame(() => attemptStart(tries + 1));
    };
    attemptStart();
    return () => {
      cancelled = true;
    };
  }, [tour, startTour]);
  useEffect(() => {
    let isMounted = true;
    if (!projectId) {
      setLoading(false);
      return () => {
        isMounted = false;
      };
    }
    try {
      const maybePromise = apiRef.current.safeInvoke(
        apiRef.current.editProject,
        projectId
      );
      maybePromise
        .then((res) => {
          if (!isMounted) return;
          setLoading(false);
          if (!res) return; // no projectId case
          setProjectDetails((prev) => ({
            ...prev,
            userId: res?.userId || "",
            currencyCode: res?.projectDTO?.currencyCode || "$",
            projectDTO: res?.projectDTO || {},
            componentDTOList:
              flattenCountComponentDTOList(res?.countComponentDTOList) || [],
            designWithVersionsDTOList: res?.designWithVersionsDTOList || [],
            locationDTO: res?.locationDTO || {},
            countComponentDTOList: res?.countComponentDTOList || [],
            designComponentsList:
              flattenDesignCountComponent(res?.designComponentsList) || [],
          }));
          if (
            res?.designWithVersionsDTOList &&
            res?.designComponentsList &&
            Array.isArray(res?.designWithVersionsDTOList) &&
            Array.isArray(res?.designComponentsList)
          ) {
            // Call the hook and set modal in state
            let hasGrid = false;
            let hasController = false;
            let versionStatus = null;
            let designComponentsList = res?.designComponentsList || [];
            let designWithVersionsDTOList =
              res?.designWithVersionsDTOList || [];
            if (Array.isArray(designComponentsList)) {
              const design = designComponentsList.find(
                (d) => String(d.designId) === String(designId)
              );
              let version;
              if (design && Array.isArray(design.designVersionComponents)) {
                version = design.designVersionComponents.find(
                  (v) => String(v.designVersionId) === String(designVersionId)
                );
              }
              const countList = version?.countComponentDTOList || [];
              hasGrid = countList.some((c) => c.componentType === "Grid");
              hasController = countList.some(
                (c) => c.componentType === "Controller"
              );
            }
            if (Array.isArray(designWithVersionsDTOList)) {
              const designObj = designWithVersionsDTOList.find(
                (d) => String(d.designDTO?.designId) === String(designId)
              );
              if (designObj && Array.isArray(designObj.designVersionDTO)) {
                const versionObj = designObj.designVersionDTO.find(
                  (v) => String(v.designVersionId) === String(designVersionId)
                );
                versionStatus = versionObj?.versionStatus || null;
              }
            }
            const canViewSimulation =
              (hasGrid && hasController) || versionStatus === "COMPLETED" || versionStatus === "READY";

            const params = new URLSearchParams(window.location.search);
            const tab = params.get("tab")?.toUpperCase();
            if (["SIMULATION", "RESULT"].includes(tab) && !canViewSimulation) {
              setBlockedTab(tab);
              setModalOpen(true);
            }
          }
          setLoadDate(
            res?.countComponentDTOList[0]?.data[0]?.componentAttributes
              ?.loadParameters?.profileDetail?.startDate
          );
        })
        .catch((err) => {
          if (!isMounted) return;
          setLoading(false);
          callSnackbar(
            "error",
            getErrorMessage(err)
          );
        });
    } catch (err) {
      setLoading(false);
      callSnackbar(
        "error",
        getErrorMessage(err)
      );
    }
    return () => {
      isMounted = false;
    };
  }, [projectId, designId, designVersionId, t, setProjectDetails, callSnackbar]);

  const handleSideMenuChange = () => {
    setCollapseSideMenu((prev) => ({
      ...prev,
      leftMenu: !prev.leftMenu,
    }));
  };

  useEffect(() => {
    return () => {
      resetCollapseSideMenu();
      resetSideMenuShow();
      resetActiveTab();
      resetProjectDetails();
      resetComponentDetails();
      resetSelectedCurrentComponent();
      resetProgressStepAtom();
      resetGridAtom();
      resetComponentStatus();
      resetActiveTab();
    };
  }, []);

  return (
    <>
      <se-snackbar
        id="snackbar2"
        icon="information_stroke"
        canClose={true}
      ></se-snackbar>
      {fallbackModal}
      {
        <SEConfirmModal
          opened={modalOpen}
          onClose={handleModalOk}
          onlyOk
          header={t("assessment.modal.designComponentMissing.header")}
          message={t("assessment.modal.designComponentMissing.message", { tab: blockedTab })}
        />
      }
      <se-container class="overFlow-x">
        <>
          <SideMenu
            projectDetails={projectDetails}
            loading={loading}
            toggleEditDetails={toggleEditDetails}
            handleSideMenuChange={handleSideMenuChange}
            setSnackBar={setSnackBar}
            snackBarRef={snackBarRef}
          />
          <main
            id="mainContent"
            style={{
              width: isFloatingMenu
                ? "calc(100%)"
                : sideMenuShow?.showMenu
                ? "calc(100% - 430px)"
                : `calc(100% - ${leftSideMenuWidth})`,
              marginLeft: leftSideMenuWidth,
              transition: "width 0.3s ease",
            }}
          >
            {loader && (
              <se-loading class="se-loading" loading={loader}></se-loading>
            )}
<SnackBarJs snackBar={snackBar} ref={snackBarRef} />
            {activeTab === "DESIGN" && (
              <div className="row">
                <LoadProject
                  loading={loading}
                  setSnackBar={setSnackBar}
                  snackBarRef={snackBarRef}
                />
              </div>
            )}
            {activeTab === "SIMULATION" && (
              <div className="row" style={{ "--bs-gutter-x": 0 }}>
                <Simulation />
              </div>
            )}
            {activeTab === "RESULT" && <Result callSnackbar={callSnackbar} />}
          </main>
          {sideMenuShow?.showMenu && (
            <RTLSideMenu onFloatingChange={setIsFloatingMenu} />
          )}
        </>

        <se-snackbar
          id="snackbar2"
          type="success"
          icon="information_stroke"
          message={t("assessment.snackbar.projectDataSuccess")}
          canClose={true}
        ></se-snackbar>
      </se-container>
      {isEditVisible &&<EditProjectDetails
        projectDetails={projectDetails}
        toggleEditDetails={toggleEditDetails}
        isEditVisible={isEditVisible}
      />}
    </>
  );
};

export default MGAAssesment;
